import React from 'react';
import '../assets/css/main.css';
import '../assets/css/nice-select2.css';
import '../assets/css/swiper-bundle.min.css';
import {Notice, initForms, initLayoutScripts} from '../assets/js/notice.js'
import article_logo from '../assets/img/article.png'
import univers_chek_logo from '../assets/img/univers-chek.png'
import zhen_chek_logo from '../assets/img/zhen-chek.png'
import vpch_logo from '../assets/img/VPCH-edited.png'
import biohim_logo from '../assets/img/biohim.png'
import cardio_logo from '../assets/img/cardio-edited.png'
import review_logo from '../assets/img/leave-review-edited.png'
import pediatrician_logo from '../assets/img/pediatrician-unlimit-edited.png'
import flebo_logo from '../assets/img/flebo-edited.png'

let was_inited = false;

export default class Visits extends React.Component {
    constructor(props) {
        super(props);

        this.state = { events: [], error_messages: props.error_messages, update_error_messages_callback: props.update_error_messages_callback,  family_data: props.family_data,
                        visits: [], future_visits: [], selected_place: "", selected_specialization: "", selected_fam_member: "", selected_service: "", selected_date_from: "",
                        selected_date_to: "", selected_date_from_temp: "", selected_date_to_temp: "", need_to_init: false, business_units_uids: [], cancel_reasons: [],
                        selected_reason: -1, cancel_rqid: "", cancel_status: "2" };

        //Если пользователь авторизован как специалист, удаляем обычный токен и меняем страницу
        if(localStorage.getItem('empAccessToken'))
        {
            localStorage.removeItem('accessToken')
            window.location = "/empschedule";
        }

        //Если пользователь не авторизован, перенаправляем его на страницу входа
        if(!localStorage.getItem('accessToken'))
            window.location = "/login";
    }

    componentDidUpdate(prevProps) {
        //Если есть ошибки, выводим всплывающее окно с ними
        if(this.state.error_messages.length > 0)
            Notice.show(this.state.error_messages.join('<br/>'));

        if(prevProps.error_messages !== this.props.error_messages)
            this.setState({error_messages: this.props.error_messages});
        if(prevProps.update_error_messages_callback !== this.props.update_error_messages_callback)
            this.setState({update_error_messages_callback: this.props.update_error_messages_callback});
        if(prevProps.family_data !== this.props.family_data)
            this.setState({family_data: this.props.family_data});

        if(this.state.need_to_init)
        {
            //Инициализируем скрипты от верстальщиков
            if(was_inited)
                initLayoutScripts();
            was_inited = true;
            initLayoutScripts();
            Notice.setHideCallback(() => { this.setState({error_messages: []}); this.state.update_error_messages_callback([]); });
            this.setState({need_to_init: false});
        }
    }

    componentDidMount() {
        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Счетчик обработанных запросов
        let requests_to_fetch = 4;
        let requests_processed = 0;

        //Запрашиваем события для карусели
        let events = [];
        fetch('/api/get-slider?code=1000001', {method: 'GET', headers:{'ZR-Access-Token': localStorage.getItem('accessToken')}})
            .then(response => response.json())
            .then(data => {
                //Парсим данные
                events = data;
                this.setState({ events: data });

                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
            })
            .catch((error) => {
                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
        //Запрашиваем прошедшие посещения
        fetch('/api/GetClVisitFullList', {method: 'POST', headers:{'ZR-Access-Token': localStorage.getItem('accessToken')}})
            .then(response => response.json())
            .then(data => {
                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //Парсим данные
                if(data.result)
                {
                    //Перебираем поля объекта
                    let visits = [];
                    for(let property in data.body)
                    {
                        //Перебираем поля вложенного объекта
                        for(let row of data.body[property])
                        {
                            //Сохраняем запись в список, перенося uid члена семьи внутрь
                            row.cluid = property;
                            visits.push(row);
                        }
                    }

                    this.setState({ visits: visits });
                }
                else
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('accessToken');
                        window.location = "/login";
                    }
            })
            .catch((error) => {
                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
        //Запрашиваем будущие посещения
        const request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken') },
            body: JSON.stringify({})
        };
        fetch('/api/GetClSched', request)
            .then(response => response.json())
            .then(data => {
                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    this.setState({loading: false});
                    return;
                }

                //Парсим данные
                if(data.result)
                {
                    //Перебираем поля объекта
                    let future_visits = [];
                    for(let property in data.body)
                    {
                        //Перебираем поля вложенного объекта
                        for(let row of data.body[property])
                        {
                            //Сохраняем запись в список, перенося uid члена семьи внутрь
                            row.cluid = property;

                            //Если запись требует оплаты
                            if(row.status == 9)
                            {
                                //Инкрементируем количество запросов для выполнения
                                ++requests_to_fetch;

                                //Запрашиваем данные по оплате
                                const request = {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken') },
                                    body: JSON.stringify({"rqid": row.rqid})
                                };
                                fetch('/api/GetPaymentByRequest', request)
                                    .then(response => response.json())
                                    .then(data => {
                                        //Переходим к запросу картинок, если всё остальное получено
                                        if(++requests_processed >= requests_to_fetch)
                                            this.get_events_images(events);

                                        //Проверяем наличие обязательных полей в ответе
                                        if(!('result' in data) || !('body' in data))
                                        {
                                            //Устанавливаем ошибку и прекращаем обработку
                                            if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                                this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                                            return;
                                        }

                                        //Парсим данные
                                        if(data.result)
                                        {
                                            row.prepay_url = data.body.conf_url.replace(/%\//g, '/');
                                            future_visits.push(row);
                                            this.setState({ future_visits: future_visits });
                                        }
                                        else
                                            //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                                            if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                                            {
                                                localStorage.removeItem('accessToken');
                                                window.location = "/login";
                                            }
                                    })
                                    .catch((error) => {
                                        //Выключаем анимацию загрузки, если все запросы обработаны
                                        if(++requests_processed >= requests_to_fetch)
                                            this.setState({loading: false, need_to_init: true});
                                        //Устанавливаем ошибку
                                        if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                            this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                                    });
                            }
                            else
                                future_visits.push(row);
                        }
                    }

                    this.setState({ future_visits: future_visits });
                }
                else
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('accessToken');
                        window.location = "/login";
                    }

                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);
            })
            .catch((error) => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false, need_to_init: true});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
        //Запрашиваем соответствия uid - название бизнес-подразделения
        fetch('/api/GetBuList', { method: 'GET', headers: { 'ZR-Access-Token': localStorage.getItem('accessToken') } })
            .then(response => response.json())
            .then(data => {
                //Переходим к запросу картинок, если всё остальное получено
                if(++requests_processed >= requests_to_fetch)
                    this.get_events_images(events);

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //Парсим данные
                if(data.result)
                    this.setState({ business_units_uids: data.body });
                else
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('accessToken');
                        window.location = "/login";
                    }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки, если все запросы обработаны
                if(++requests_processed >= requests_to_fetch)
                    this.setState({loading: false, need_to_init: true});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
    }

    get_events_images = (events_original) => {
        //Если event`ов нет, выходим
        if(events_original.length === 0)
        {
            this.setState({loading: false, need_to_init: true});
            return;
        }

        let events = events_original;
        let events_quantity = events_original.length;
        let events_processed = 0;
        for(let even_t of events)
        {
            //Запрашиваем аватар
            fetch('/api/GetImageById', {method: 'POST', headers:{'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken')},
                body: JSON.stringify({ "imgId": even_t.file_id })})
                .then(response => response.json())
                .then(data => {
                    //Выключаем анимацию загрузки, если все запросы обработаны
                    if(++events_processed >= events_quantity)
                        this.setState({loading: false, need_to_init: true});

                    //Проверяем наличие обязательных полей в ответе
                    if(!('result' in data) || !('body' in data))
                        return;
                    else
                    {
                        //В случае ошибки добавляем ее в состояние
                        if(!data.result)
                        {
                            //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                            if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                            {
                                localStorage.removeItem('accessToken');
                                window.location = "/login";
                            }
                        }
                        else
                        {
                            if(!('base64data' in data.body))
                                return;

                            //Парсим данные
                            even_t.bnr_img = data.body.base64data;
                        }
                    }

                    //Сохраняем результат, если все запросы обработаны
                    if(events_processed >= events_quantity)
                        this.setState({events: events});
                })
                .catch((error) => {
                    //Выключаем анимацию загрузки, если все запросы обработаны
                    if(++events_processed >= events_quantity)
                        this.setState({loading: false, need_to_init: true});
                });
        }
    }

    changeDateFormat = (date) => {
        if(date.length < 10)
            return date;
        let new_date = date[8] + date[9] + '.' + date[5] + date[6] + '.' + date[0] + date[1] + date[2] + date[3] + date.substring(10, date.length);
        return new_date;
    }

    compareDates = (date1, date2) => {
        var date_object1 = Date.parse(date1.split(' ')[0]);
        var date_object2 = Date.parse(date2.split(' ')[0]);

        return date_object1 >= date_object2;
    }

    render() {
        return (
            <>
                {this.state.loading &&
                <div class="pre-loader">
                    <div class="loader-spinner">
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                }

                {this.state.events.length !== 0 &&
                <div class="articles">
                    <p class="block-title">
                        ДЛЯ ВАС
                    </p>
                    <div class="swiper">
                        <div class="swiper-wrapper">
                            {this.state.events.map((data, index) =>
                                <div class="swiper-slide" key={index}>
                                    <a href={data.bnr_href} class="articles--item" target="_blank">
                                        <img style={{backgroundImage: `url(data:image/jpeg;base64,${data.bnr_img})`}} class="articles--item__image"></img>
                                        <p class="articles--item__title">
                                            {data.bnr_name}
                                        </p>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                    <div class="navigation-item navigation-prev">
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11.5" transform="rotate(-180 11.5 11.5)" fill="#7E7E7E"/>
                            <path d="M14.7158 5.63439C14.3416 5.26016 13.7348 5.26016 13.3606 5.63439L8.6768 10.3228C7.92892 11.0714 7.92921 12.2845 8.67738 13.0327L13.364 17.7193C13.7382 18.0936 14.3451 18.0936 14.7193 17.7193C15.0936 17.3451 15.0936 16.7383 14.7193 16.364L10.7081 12.3528C10.3338 11.9786 10.3338 11.3717 10.7081 10.9975L14.7158 6.98966C15.0901 6.61543 15.0901 6.00871 14.7158 5.63439Z" fill="white"/>
                        </svg>
                    </div>
                    <div class="navigation-item navigation-next">
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11.5" fill="#7E7E7E"/>
                            <path d="M8.28415 17.3656C8.65839 17.7398 9.26521 17.7398 9.63944 17.3656L14.3232 12.6772C15.0711 11.9286 15.0708 10.7155 14.3226 9.96728L9.63599 5.28069C9.26176 4.90644 8.65494 4.90644 8.28069 5.28069C7.90644 5.65494 7.90644 6.26172 8.28069 6.63598L12.2919 10.6472C12.6662 11.0214 12.6662 11.6283 12.2919 12.0025L8.28415 16.0103C7.90989 16.3846 7.90989 16.9913 8.28415 17.3656Z" fill="white"/>
                        </svg>
                    </div>
                </div>}
                <div class="filter">
                    <div class="filter--inner">
                        <form action="">
                            <span class="filter--close">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.16699 22.8327L22.6159 1.38377M1.16699 1.16602L22.6159 22.6149" stroke="#D30D15" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                            <p class="filter--title">
                                ФИЛЬТР
                            </p>
                            <div class={this.state.selected_place !== "" ? "filter--item with-dropdown filled" : "filter--item with-dropdown"}>
                                <span class="icon">
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.6667 6.7691V12.6559C15.6667 14.1959 15.6667 14.966 15.3669 15.5543C15.1033 16.0717 14.6826 16.4925 14.1652 16.7561C13.5769 17.0559 12.8068 17.0559 11.2667 17.0559H7.23333C5.69319 17.0559 4.92311 17.0559 4.33486 16.7561C3.81741 16.4925 3.39672 16.0717 3.13307 15.5543C2.83333 14.966 2.83333 14.1959 2.83333 12.6559V6.7685M17.5 8.80586L12.5196 3.27281C11.3868 2.01445 10.8205 1.38526 10.1535 1.15298C9.56772 0.948961 8.93008 0.949007 8.34424 1.15311C7.67727 1.3855 7.11106 2.01476 5.97855 3.2733L1 8.80586M9.25 8.80586V12.4725M11.0833 10.6392H7.41667" stroke="#D30D15" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                Филиал
                                <div class="with-dropdown--menu">
                                    <div class="with-dropdown--menu__inner">
                                        <div class="scroll">
                                            <label class="with-dropdown--menu__item">
                                                <input class="hidden-input" type="checkbox" value="" checked={this.state.selected_place === ""} onChange={(e) => this.setState({ selected_place: "" })}></input>
                                                <span>Филиал</span>
                                            </label>
                                            {this.state.business_units_uids.filter((data) => this.state.future_visits.some((item) => item.buid === data.onec_uid) || this.state.visits.some((item) => item.buid === data.onec_uid)).sort((a, b) => a.bu_name.localeCompare(b.bu_name)).map((elem, index) =>
                                                <label class="with-dropdown--menu__item" key={index}>
                                                    <input class="hidden-input" type="checkbox" value={elem.onec_uid} checked={this.state.selected_place === elem.onec_uid} onChange={(e) => this.setState({ selected_place: e.target.value })}></input>
                                                    <span>{elem.bu_name}</span>
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class={this.state.selected_date_from !== "" ? "filter--item with-dropdown with-dropdown-date filled" : "filter--item with-dropdown with-dropdown-date"}>
                                <span class="icon">
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.33333 15H11.6667C12.2855 15 12.879 14.7629 13.3166 14.341C13.7542 13.919 14 13.3467 14 12.75V3.75C14 3.35218 13.8361 2.97064 13.5444 2.68934C13.2527 2.40804 12.857 2.25 12.4444 2.25H10.8889V0.75C10.8889 0.551088 10.8069 0.360322 10.6611 0.21967C10.5152 0.0790176 10.3174 0 10.1111 0C9.90483 0 9.707 0.0790176 9.56114 0.21967C9.41528 0.360322 9.33333 0.551088 9.33333 0.75V2.25H4.66667V0.75C4.66667 0.551088 4.58472 0.360322 4.43886 0.21967C4.293 0.0790176 4.09517 0 3.88889 0C3.68261 0 3.48478 0.0790176 3.33892 0.21967C3.19306 0.360322 3.11111 0.551088 3.11111 0.75V2.25H1.55556C1.143 2.25 0.747335 2.40804 0.455612 2.68934C0.163888 2.97064 0 3.35218 0 3.75V12.75C0 13.3467 0.245833 13.919 0.683418 14.341C1.121 14.7629 1.71449 15 2.33333 15ZM1.55556 7.875C1.55556 7.77554 1.59653 7.68016 1.66946 7.60983C1.74239 7.53951 1.8413 7.5 1.94444 7.5H12.0556C12.1587 7.5 12.2576 7.53951 12.3305 7.60983C12.4035 7.68016 12.4444 7.77554 12.4444 7.875V12.75C12.4444 12.9489 12.3625 13.1397 12.2166 13.2803C12.0708 13.421 11.8729 13.5 11.6667 13.5H2.33333C2.12705 13.5 1.92922 13.421 1.78336 13.2803C1.6375 13.1397 1.55556 12.9489 1.55556 12.75V7.875Z" fill="#D30D15"/>
                                    </svg>
                                </span>
                                Дата От
                                <div class="with-dropdown--menu date--menu">
                                    <div class="with-dropdown--menu__inner">
                                        <form>
                                            <input type="date" value={this.state.selected_date_from_temp} onChange={(e) => this.setState({selected_date_from_temp: e.target.value})}></input>
                                            <button type="submit" onClick={(e) => { e.preventDefault(); this.setState({selected_date_from: this.state.selected_date_from_temp}); e.target.closest('.with-dropdown').classList.remove('open'); }}>Ок</button>
                                            <button onClick={(e) => { e.preventDefault(); this.setState({selected_date_from: "", selected_date_from_temp: ""}); e.target.closest('.with-dropdown').classList.remove('open'); }}>Сброс</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class={this.state.selected_date_to !== "" ? "filter--item with-dropdown with-dropdown-date filled" : "filter--item with-dropdown with-dropdown-date"}>
                                <span class="icon">
                                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.33333 15H11.6667C12.2855 15 12.879 14.7629 13.3166 14.341C13.7542 13.919 14 13.3467 14 12.75V3.75C14 3.35218 13.8361 2.97064 13.5444 2.68934C13.2527 2.40804 12.857 2.25 12.4444 2.25H10.8889V0.75C10.8889 0.551088 10.8069 0.360322 10.6611 0.21967C10.5152 0.0790176 10.3174 0 10.1111 0C9.90483 0 9.707 0.0790176 9.56114 0.21967C9.41528 0.360322 9.33333 0.551088 9.33333 0.75V2.25H4.66667V0.75C4.66667 0.551088 4.58472 0.360322 4.43886 0.21967C4.293 0.0790176 4.09517 0 3.88889 0C3.68261 0 3.48478 0.0790176 3.33892 0.21967C3.19306 0.360322 3.11111 0.551088 3.11111 0.75V2.25H1.55556C1.143 2.25 0.747335 2.40804 0.455612 2.68934C0.163888 2.97064 0 3.35218 0 3.75V12.75C0 13.3467 0.245833 13.919 0.683418 14.341C1.121 14.7629 1.71449 15 2.33333 15ZM1.55556 7.875C1.55556 7.77554 1.59653 7.68016 1.66946 7.60983C1.74239 7.53951 1.8413 7.5 1.94444 7.5H12.0556C12.1587 7.5 12.2576 7.53951 12.3305 7.60983C12.4035 7.68016 12.4444 7.77554 12.4444 7.875V12.75C12.4444 12.9489 12.3625 13.1397 12.2166 13.2803C12.0708 13.421 11.8729 13.5 11.6667 13.5H2.33333C2.12705 13.5 1.92922 13.421 1.78336 13.2803C1.6375 13.1397 1.55556 12.9489 1.55556 12.75V7.875Z" fill="#D30D15"/>
                                    </svg>
                                </span>
                                Дата До
                                <div class="with-dropdown--menu date--menu">
                                    <div class="with-dropdown--menu__inner">
                                        <form>
                                            <input type="date" value={this.state.selected_date_to_temp} onChange={(e) => this.setState({selected_date_to_temp: e.target.value})}></input>
                                            <button type="submit" onClick={(e) => { e.preventDefault(); this.setState({selected_date_to: this.state.selected_date_to_temp}); e.target.closest('.with-dropdown').classList.remove('open'); }}>Ок</button>
                                            <button onClick={(e) => { e.preventDefault(); this.setState({selected_date_to: "", selected_date_to_temp: ""}); e.target.closest('.with-dropdown').classList.remove('open'); }}>Сброс</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class={this.state.selected_service !== "" ? "filter--item with-dropdown filled" : "filter--item with-dropdown"}>
                                <span class="icon">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.33301 1.66602H11.6663C12.3294 1.66602 12.9653 1.92941 13.4341 2.39825C13.9029 2.86709 14.1663 3.50297 14.1663 4.16602V4.99935H15.833C16.496 4.99935 17.1319 5.26274 17.6008 5.73158C18.0696 6.20042 18.333 6.83631 18.333 7.49935V15.8327C18.333 16.4957 18.0696 17.1316 17.6008 17.6004C17.1319 18.0693 16.496 18.3327 15.833 18.3327H4.16634C3.5033 18.3327 2.86742 18.0693 2.39858 17.6004C1.92974 17.1316 1.66634 16.4957 1.66634 15.8327V7.49935C1.66634 6.83631 1.92974 6.20042 2.39858 5.73158C2.86742 5.26274 3.5033 4.99935 4.16634 4.99935H5.83301V4.16602C5.83301 3.50297 6.0964 2.86709 6.56524 2.39825C7.03408 1.92941 7.66997 1.66602 8.33301 1.66602ZM12.4997 4.16602C12.4997 3.945 12.4119 3.73304 12.2556 3.57676C12.0993 3.42048 11.8874 3.33268 11.6663 3.33268H8.33301C8.112 3.33268 7.90003 3.42048 7.74375 3.57676C7.58747 3.73304 7.49968 3.945 7.49968 4.16602V4.99935H12.4997V4.16602ZM3.33301 7.49935V15.8327C3.33301 16.0537 3.42081 16.2657 3.57709 16.4219C3.73337 16.5782 3.94533 16.666 4.16634 16.666H15.833C16.054 16.666 16.266 16.5782 16.4223 16.4219C16.5785 16.2657 16.6663 16.0537 16.6663 15.8327V7.49935C16.6663 7.27833 16.5785 7.06637 16.4223 6.91009C16.266 6.75381 16.054 6.66601 15.833 6.66601H4.16634C3.94533 6.66601 3.73337 6.75381 3.57709 6.91009C3.42081 7.06637 3.33301 7.27833 3.33301 7.49935ZM9.16634 10.8327H7.49968V12.4993H9.16634V14.166H10.833V12.4993H12.4997V10.8327H10.833V9.16601H9.16634V10.8327Z" fill="#D30D15"/>
                                    </svg>
                                </span>
                                Услуга
                                <div class="with-dropdown--menu">
                                    <div class="with-dropdown--menu__inner">
                                        <div class="scroll">
                                            <label class="with-dropdown--menu__item">
                                                <input class="hidden-input" type="checkbox" value="" checked={this.state.selected_service === ""} onChange={(e) => this.setState({ selected_service: "" })}></input>
                                                <span>Услуга</span>
                                            </label>
                                            {[...new Set([...this.state.future_visits.map((data) => data.name), ...this.state.visits.map((data) => data.name)])].map((elem, index) =>
                                                <label class="with-dropdown--menu__item" key={index}>
                                                    <input class="hidden-input" type="checkbox" value={elem} checked={this.state.selected_service === elem} onChange={(e) => this.setState({ selected_service: e.target.value })}></input>
                                                    <span>{elem}</span>
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class={this.state.selected_fam_member !== "" ? "filter--item with-dropdown filled" : "filter--item with-dropdown"}>
                                <span class="icon">
                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 13.0625C0 10.6741 1.52241 8.64123 3.64976 7.8815C4.22796 7.67497 4.85084 7.5625 5.5 7.5625C6.14916 7.5625 6.77206 7.67497 7.3502 7.8815C7.66434 7.99361 7.96519 8.13358 8.25 8.29831C8.53481 8.13358 8.83566 7.99361 9.1498 7.8815C9.72794 7.67497 10.3508 7.5625 11 7.5625C11.6492 7.5625 12.2721 7.67497 12.8502 7.8815C14.9776 8.64123 16.5 10.6741 16.5 13.0625V15.8125H11.6875V14.4375H15.125V13.0625C15.125 10.7843 13.2782 8.9375 11 8.9375C10.4527 8.9375 9.93025 9.04411 9.4523 9.23771C10.4104 10.2275 11 11.5761 11 13.0625V15.8125H0V13.0625ZM5.5 6.875C4.86845 6.875 4.27669 6.70468 3.76812 6.4075C2.74789 5.8113 2.0625 4.70443 2.0625 3.4375C2.0625 1.53902 3.60152 0 5.5 0C6.62448 0 7.62282 0.539926 8.25 1.37466C8.87718 0.539926 9.87552 0 11 0C12.8985 0 14.4375 1.53902 14.4375 3.4375C14.4375 4.70443 13.7521 5.8113 12.7319 6.4075C12.2233 6.70468 11.6316 6.875 11 6.875C10.3684 6.875 9.77671 6.70468 9.26814 6.4075C8.87113 6.17549 8.52491 5.86621 8.25 5.50033C7.97509 5.8663 7.62887 6.17549 7.23186 6.4075C6.72329 6.70468 6.13155 6.875 5.5 6.875ZM9.625 13.0625V14.4375H1.375V13.0625C1.375 10.7843 3.22183 8.9375 5.5 8.9375C7.77819 8.9375 9.625 10.7843 9.625 13.0625ZM7.5625 3.4375C7.5625 4.57659 6.63905 5.5 5.5 5.5C4.36091 5.5 3.4375 4.57659 3.4375 3.4375C3.4375 2.29841 4.36091 1.375 5.5 1.375C6.63905 1.375 7.5625 2.29841 7.5625 3.4375ZM11 1.375C9.86095 1.375 8.9375 2.29841 8.9375 3.4375C8.9375 4.57659 9.86095 5.5 11 5.5C12.139 5.5 13.0625 4.57659 13.0625 3.4375C13.0625 2.29841 12.139 1.375 11 1.375Z" fill="#D30D15"/>
                                    </svg>
                                </span>
                                Кто был на приёме
                                <div class="with-dropdown--menu">
                                    <div class="with-dropdown--menu__inner">
                                        <div class="scroll">
                                            <label class="with-dropdown--menu__item">
                                                <input class="hidden-input" type="checkbox" value="" checked={this.state.selected_fam_member === ""} onChange={(e) => this.setState({ selected_fam_member: "" })}></input>
                                                <span>Кто был на приёме</span>
                                            </label>
                                            {this.state.family_data.filter((data) => this.state.visits.some((data_internal) => data_internal.cluid === data.uid) || this.state.future_visits.some((data_internal) => data_internal.cluid === data.uid)).sort((a, b) => a.name.localeCompare(b.name)).map((elem, index) =>
                                                <label class="with-dropdown--menu__item" key={index}>
                                                    <input class="hidden-input" type="checkbox" value={elem.uid} checked={this.state.selected_fam_member === elem.uid} onChange={(e) => this.setState({ selected_fam_member: e.target.value })}></input>
                                                    <span>{elem.name}</span>
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="split">
                        <p class="block-title">
                            ПРЕДСТОЯЩИЕ ЗАПИСИ
                        </p>
                        <p class="filter-mobile-icon">
                            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.56326 0.000113221C6.59768 0.000179888 6.63216 0.000235345 6.66667 0.000235345C6.70122 0.000235345 6.73567 0.000179888 6.77011 0.000113221C7.17978 -0.000564556 7.58245 -0.00123153 7.94111 0.0948796C8.89978 0.351735 9.64844 1.10048 9.90533 2.05907C10.0014 2.41778 10.0008 2.82046 10.0001 3.23015C10.0001 3.26458 10 3.29906 10 3.33357H18.8889C19.5026 3.33357 20 3.83102 20 4.44468C20 5.05832 19.5026 5.55579 18.8889 5.55579H10C10 5.5903 10.0001 5.62478 10.0001 5.65921C10.0008 6.0689 10.0014 6.47158 9.90533 6.83034C9.64844 7.78889 8.89978 8.53767 7.94111 8.79445C7.58245 8.89056 7.17978 8.88989 6.77011 8.88923C6.73567 8.88923 6.70122 8.88911 6.66667 8.88911C6.63216 8.88911 6.59768 8.88923 6.56325 8.88923C6.15356 8.88989 5.75088 8.89056 5.39217 8.79445C4.43358 8.53767 3.68483 7.78889 3.42799 6.83034C3.33187 6.47157 3.33253 6.0689 3.33322 5.6592C3.33328 5.62478 3.33333 5.59029 3.33333 5.55579H1.11111C0.497467 5.55579 0 5.05832 0 4.44468C0 3.83102 0.497467 3.33357 1.11111 3.33357H3.33333C3.33333 3.29906 3.33328 3.26458 3.33322 3.23015C3.33253 2.82046 3.33187 2.41778 3.42799 2.05907C3.68483 1.10048 4.43358 0.351735 5.39217 0.0948796C5.75088 -0.00123153 6.15356 -0.000564556 6.56326 0.000113221ZM6.10957 2.2284C5.99106 2.2338 5.96317 2.2425 5.96732 2.24138C5.7756 2.29276 5.62586 2.4425 5.57449 2.63422C5.57356 2.63812 5.56626 2.67226 5.5615 2.77646C5.55582 2.90094 5.55556 3.06517 5.55556 3.33357V5.55579C5.55556 5.82418 5.55582 5.98841 5.5615 6.11289C5.5669 6.2314 5.5756 6.25928 5.57449 6.25514C5.62586 6.44685 5.7756 6.5966 5.96732 6.64797C5.96317 6.64686 5.99106 6.65555 6.10957 6.66096C6.23403 6.66664 6.39827 6.66689 6.66667 6.66689C6.93511 6.66689 7.09933 6.66664 7.22378 6.66096C7.34222 6.65555 7.37011 6.64686 7.366 6.64797C7.55778 6.5966 7.70744 6.44685 7.75889 6.25514C7.75778 6.25928 7.76645 6.2314 7.77178 6.11289C7.77756 5.98841 7.77778 5.82418 7.77778 5.55579V3.33357C7.77778 3.06517 7.77756 2.90094 7.77178 2.77646C7.76645 2.65796 7.75778 2.63007 7.75889 2.63422M6.10957 2.2284C6.23403 2.22272 6.39827 2.22246 6.66667 2.22246L6.10957 2.2284ZM6.66667 2.22246C6.93511 2.22246 7.09933 2.22272 7.22378 2.2284L6.66667 2.22246ZM7.22378 2.2284C7.328 2.23315 7.36211 2.24045 7.366 2.24138L7.22378 2.2284ZM13.2299 8.889C13.2643 8.88911 13.2988 8.88911 13.3333 8.88911C13.3679 8.88911 13.4023 8.88911 13.4368 8.889C13.8464 8.88834 14.2491 8.88767 14.6078 8.98378C15.5664 9.24067 16.3151 9.98934 16.572 10.948C16.6681 11.3067 16.6674 11.7093 16.6668 12.119C16.6668 12.1534 16.6667 12.1879 16.6667 12.2224H18.8889C19.5026 12.2224 20 12.7199 20 13.3336C20 13.9472 19.5026 14.4447 18.8889 14.4447H16.6667C16.6667 14.4792 16.6668 14.5137 16.6668 14.5481C16.6674 14.9578 16.6681 15.3604 16.572 15.7192C16.3151 16.6778 15.5664 17.4266 14.6078 17.6833C14.2491 17.7794 13.8464 17.7788 13.4368 17.7781C13.4023 17.7781 13.3679 17.778 13.3333 17.778C13.2988 17.778 13.2643 17.7781 13.2299 17.7781C12.8202 17.7788 12.4176 17.7794 12.0589 17.6833C11.1002 17.4266 10.3516 16.6778 10.0947 15.7192C9.99856 15.3604 9.99922 14.9578 9.99989 14.5481C9.99989 14.5137 10 14.4792 10 14.4447H1.11111C0.497467 14.4447 0 13.9472 0 13.3336C0 12.7199 0.497467 12.2224 1.11111 12.2224H10C10 12.188 9.99989 12.1534 9.99989 12.119C9.99922 11.7093 9.99856 11.3067 10.0947 10.948C10.3516 9.98934 11.1002 9.24067 12.0589 8.98378C12.4176 8.88767 12.8202 8.88834 13.2299 8.889ZM12.7762 11.1173C12.6578 11.1227 12.6299 11.1313 12.634 11.1302C12.4422 11.1817 12.2926 11.3314 12.2411 11.5231C12.2422 11.519 12.2336 11.5469 12.2282 11.6653C12.2224 11.7898 12.2222 11.9541 12.2222 12.2224V14.4447C12.2222 14.7131 12.2224 14.8773 12.2282 15.0018C12.2336 15.1203 12.2422 15.1482 12.2411 15.144C12.2926 15.3358 12.4422 15.4854 12.634 15.5369C12.6299 15.5358 12.6578 15.5444 12.7762 15.5499C12.9007 15.5556 13.0649 15.5558 13.3333 15.5558C13.6018 15.5558 13.766 15.5556 13.8904 15.5499C14.0089 15.5444 14.0368 15.5358 14.0327 15.5369C14.2244 15.4854 14.3741 15.3358 14.4256 15.144C14.4244 15.1482 14.4331 15.1203 14.4384 15.0018C14.4442 14.8773 14.4444 14.7131 14.4444 14.4447V12.2224C14.4444 11.9541 14.4442 11.7898 14.4384 11.6653C14.4331 11.5469 14.4244 11.519 14.4256 11.5231C14.3741 11.3314 14.2244 11.1817 14.0327 11.1302C14.0368 11.1313 14.0089 11.1227 13.8904 11.1173C13.766 11.1116 13.6018 11.1113 13.3333 11.1113C13.0649 11.1113 12.9007 11.1116 12.7762 11.1173Z" fill="#D30D15"/>
                            </svg>
                            <span>
                                ФИЛЬТР
                            </span>
                        </p>
                    </div>
                    <div class="row-list">
                        {this.state.future_visits.filter((data) => !this.state.selected_place.length || data.buid === this.state.selected_place)
                            .filter((data) => !this.state.selected_service.length || data.name === this.state.selected_service)
                            .filter((data) => !this.state.selected_fam_member.length || data.cluid === this.state.selected_fam_member)
                            .filter((data) => !this.state.selected_date_from.length || this.compareDates(data.date, this.state.selected_date_from.replaceAll('-', '.')))
                            .filter((data) => !this.state.selected_date_to.length || this.compareDates(this.state.selected_date_to.replaceAll('-', '.'), data.date))
                            .sort((a, b) => a.date > b.date).map((data, index) =>
                            <div class="row-list--item reception" key={index}>
                                <p class="date">
                                    {this.changeDateFormat(data.date.split(" ")[0])} {data.date.split(" ")[1].substr(0, data.date.split(" ")[1].length - 3)}
                                </p>
                                <p class="title">
                                    <b>{data.name}</b>
                                </p>
                                <p class="doctor">
                                    {data.empfio}
                                </p>
                                <p class="address">
                                    {(this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid).length !== 0) && this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid)[0].bu_name}
                                    {(this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid).length === 0) && "Адрес не указан"}
                                </p>
                                <p class="pacient">
                                    {this.state.family_data.filter((family_data) => family_data.uid == data.cluid).length ? this.state.family_data.filter((family_data) => family_data.uid == data.cluid)[0].name : ""}
                                </p>
                                <p class="visit_control">
                                    {data.status && data.status == 11 &&
                                    <div class="prepay-info">Предоплата внесена</div>}
                                    {data.status && data.status == 9 && data.prepay_url &&
                                    <a href={data.prepay_url}><button class="prepay">Оплатить</button></a>}
                                    {data.status && data.status != 9 && data.status != 11 &&
                                    <div class="prepay-info">Предоплата не требуется</div>}
                                    <button class="cancel" data-rqid={data.rqid} data-status={data.status} onClick={this.cancelAppointment}>Отменить запись</button>
                                </p>
                            </div>)}
                        {this.state.future_visits.filter((data) => !this.state.selected_place.length || data.buid === this.state.selected_place)
                            .filter((data) => !this.state.selected_service.length || data.name === this.state.selected_service)
                            .filter((data) => !this.state.selected_fam_member.length || data.cluid === this.state.selected_fam_member)
                            .filter((data) => !this.state.selected_date_from.length || this.compareDates(data.date, this.state.selected_date_from.replaceAll('-', '.')))
                            .filter((data) => !this.state.selected_date_to.length || this.compareDates(this.state.selected_date_to.replaceAll('-', '.'), data.date)).length === 0 && <div>Записи отсутствуют</div>}
                    </div>
                </div>
                <div class="row">
                    <div class="split">
                        <p class="block-title">
                            МОЯ ИСТОРИЯ
                        </p>
                    </div>
                    <div class="row-list">
                        {this.state.visits.filter((data) => !this.state.selected_place.length || data.buid === this.state.selected_place)
                            .filter((data) => !this.state.selected_service.length || data.name === this.state.selected_service)
                            .filter((data) => !this.state.selected_fam_member.length || data.cluid === this.state.selected_fam_member)
                            .filter((data) => !this.state.selected_date_from.length || this.compareDates(data.date, this.state.selected_date_from.replaceAll('-', '.')))
                            .filter((data) => !this.state.selected_date_to.length || this.compareDates(this.state.selected_date_to.replaceAll('-', '.'), data.date))
                            .sort((a, b) => a.date > b.date).map((data, index) =>

                            <div class="row-list--item reception finish" key={index}>
                                <p class="date">
                                    {data.date && this.changeDateFormat(data.date.split(" ")[0])}
                                </p>
                                <p class="title">
                                    <b>{data.name}</b>
                                </p>
                                <p class="doctor">
                                    {data.empfio}
                                </p>
                                <p class="address">
                                    {(this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid).length !== 0) && this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid)[0].bu_name}
                                    {(this.state.business_units_uids.filter((bu_data) => data.buid != null && bu_data.onec_uid == data.buid).length === 0) && "Адрес не указан"}
                                </p>
                                <p class="pacient">
                                    {this.state.family_data.filter((family_data) => family_data.uid == data.cluid).length ? this.state.family_data.filter((family_data) => family_data.uid == data.cluid)[0].name : ""}
                                </p>
                                {data.document_url &&
                                    <a href="#" class="status finish" data-url={data.document_url} onClick={this.openTestDoc}>
                                    Заключение
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.714 6.14807L14.259 0.363037C14.07 0.164037 13.803 0 13.529 0H1.979C0.874004 0 0 1 0 2.104V9.104C0 9.656 0.437014 10 0.989014 10H0.993988C1.54699 10 2 9.656 2 9.104V3.104C2 2.552 2.427 2 2.979 2H12V6.104C12 7.209 12.874 8 13.979 8H18V9.104C18 9.656 18.437 10 18.989 10H18.994C19.547 10 20 9.656 20 9.104V6.83704C20 6.58004 19.891 6.33407 19.714 6.14807ZM3.979 15.104C3.979 14.552 3.531 14.104 2.979 14.104H1.979V16.104H2.979C3.531 16.104 3.979 15.656 3.979 15.104ZM5.97501 14.838C6.06501 16.568 4.689 18 2.979 18H2V19.104C2 19.656 1.54699 20 0.993988 20H0.989014C0.437014 20 0 19.656 0 19.104V13.104C0 12.552 0.427004 12 0.979004 12H2.80899C4.43399 12 5.89001 13.216 5.97501 14.838ZM11 15.104C11 14.552 10.531 14 9.979 14H9V18H9.979C10.531 18 11 17.656 11 17.104V15.104ZM13 15V17C13 18.65 11.65 20 10 20H7.89499C7.39999 20 7 19.599 7 19.104V12.979C7 12.438 7.438 12 7.979 12H10C11.65 12 13 13.35 13 15ZM20 13.026V13.052C20 13.604 19.531 14 18.979 14H16V16H18.979C19.531 16 20 16.473 20 17.026V17.052C20 17.604 19.531 18 18.979 18H16V19.104C16 19.656 15.547 20 14.994 20H14.989C14.437 20 14 19.656 14 19.104V13.104C14 12.552 14.427 12 14.979 12H18.979C19.531 12 20 12.473 20 13.026Z" fill="#D30D15"/>
                                    </svg>
                                </a>
                                }
                            </div>)}
                        {this.state.visits.filter((data) => !this.state.selected_place.length || data.buid === this.state.selected_place)
                            .filter((data) => !this.state.selected_service.length || data.name === this.state.selected_service)
                            .filter((data) => !this.state.selected_fam_member.length || data.cluid === this.state.selected_fam_member)
                            .filter((data) => !this.state.selected_date_from.length || this.compareDates(data.date, this.state.selected_date_from.replaceAll('-', '.')))
                            .filter((data) => !this.state.selected_date_to.length || this.compareDates(this.state.selected_date_to.replaceAll('-', '.'), data.date)).length === 0 && <div>Посещения отсутствуют</div>}
                    </div>
                </div>
                <div id="cancel_modal" class="modal">
                    <div class="modal-content">
                        <div class="modal-content--close">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.16699 22.8327L22.6159 1.38377M1.16699 1.16602L22.6159 22.6149" stroke="#D30D15" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p class="modal-content--title">
                            Отмена записи
                        </p>
                        <div>
                        {this.state.cancel_status == 11 &&
                        <h2 class="cancel_warning">Обратите внимание, что возврат средств производится только по заявлению непосредственно в клинике</h2>}
                        <p>Пожалуйста, выберите причину отмены:</p>
                            <div class="onec-variants">
                                {this.state.cancel_reasons.map((data, index) =>
                                    <div key={index}>
                                        <input id={"reason" + index} name={"reason" + index} type="radio" checked={this.state.selected_reason == index} onChange={(e) => this.setState({ selected_reason: index })}></input>
                                        <label htmlFor={"reason" + index}>{data.evсname}</label>
                                    </div>
                                )}
                            </div>
                            <button type="button" class="button-primary button-onec" onClick={this.confirmCancel}>Подтвердить</button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    openTestDoc = (e) => {
        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Запрашиваем документ указанного анализа
        fetch('/document/' + e.currentTarget.dataset.url, {method: 'GET', headers:{'ZR-Access-Token': localStorage.getItem('accessToken')}})
            .then(response => response.blob())
            .then(data => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});

                //Получаем url и открываем в новой вкладке
                let doc_url = URL.createObjectURL(data);
                window.open(doc_url, '_blank').focus();
            })
            .catch((error) => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
    }

    cancelAppointment = (e) => {
        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Сохраняем rqid и status для дальнейшей обработки
        let rqid = e.currentTarget.dataset.rqid;
        let status = e.currentTarget.dataset.status;

        //Запрашиваем список причин отмены
        fetch('/api/GetEvcList', {method: 'GET', headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken') }})
            .then(response => response.json())
            .then(data => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //В случае ошибки добавляем ее в состояние
                if(data.result === false)
                {
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('accessToken');
                        window.location = "/login";
                    }
                    else
                    {
                        if(this.state.error_messages.indexOf(data.body.errorAns) === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, data.body.errorAns]);
                    }
                }
                else
                {
                    //Сохраняем данные
                    let cancel_reasons = [];
                    for(let reason of data.body)
                        if(reason.isGroup === false)
                            cancel_reasons.push(reason);
                    this.setState({cancel_reasons: cancel_reasons, selected_reason: -1, cancel_rqid: rqid, cancel_status: status});

                    //Открываем модальное окно
                    const form = document.getElementById("cancel_modal")
                    if(form) {
                        form.classList.add('open')
                    }
                }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
    }

    confirmCancel = (e) => {
        e.preventDefault();

        //Убеждаемся, что причина отмены выбрана
        if(this.state.selected_reason === -1)
        {
            //Устанавливаем ошибку и выходим
            if(this.state.error_messages.indexOf("Не выбрана причина отмены") === -1)
                this.state.update_error_messages_callback([...this.state.error_messages, "Не выбрана причина отмены"]);
            return
        }

        //Включаем анимацию загрузки
        this.setState({ loading: true });

        //Запрашиваем отмену записи
        const request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken') },
            body: JSON.stringify({"rqid": this.state.cancel_rqid, "evсid": this.state.cancel_reasons[this.state.selected_reason].evсid})
        };
        fetch('/api/CancelRequest', request)
            .then(response => response.json())
            .then(data => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});

                //Проверяем наличие обязательных полей в ответе
                if(!('result' in data) || !('body' in data))
                {
                    //Устанавливаем ошибку и прекращаем обработку
                    if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                        this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                    return;
                }

                //В случае ошибки добавляем ее в состояние
                if(data.result === false)
                {
                    //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                    if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                    {
                        localStorage.removeItem('accessToken');
                        window.location = "/login";
                    }
                    else
                        if(this.state.error_messages.indexOf(data.body.errorAns) === -1)
                            this.state.update_error_messages_callback([...this.state.error_messages, data.body.errorAns]);
                }
                //Иначе - переспрашиваем список будущих посещений
                else
                {
                    //Закрываем модальное окно
                    const form = document.getElementById("cancel_modal")
                    if(form) {
                        form.classList.remove('open');
                    }

                    //Включаем анимацию загрузки
                    this.setState({loading: true});

                    //Запрашиваем будущие посещения
                    const request = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'ZR-Access-Token': localStorage.getItem('accessToken') },
                        body: JSON.stringify({})
                    };
                    fetch('/api/GetClSched', request)
                        .then(response => response.json())
                        .then(data => {
                            //Выключаем анимацию загрузки
                            this.setState({loading: false});

                            //Проверяем наличие обязательных полей в ответе
                            if(!('result' in data) || !('body' in data))
                            {
                                //Устанавливаем ошибку и прекращаем обработку
                                if(this.state.error_messages.indexOf("Получен некорректный ответ от сервера") === -1)
                                    this.state.update_error_messages_callback([...this.state.error_messages, "Получен некорректный ответ от сервера"]);
                                return;
                            }

                            //Парсим данные
                            if(data.result)
                            {
                                //Перебираем поля объекта
                                let future_visits = [];
                                for(let property in data.body)
                                {
                                    //Перебираем поля вложенного объекта
                                    for(let row of data.body[property])
                                    {
                                        //Сохраняем запись в список, перенося uid члена семьи внутрь
                                        row.cluid = property;
                                        future_visits.push(row);
                                    }
                                }

                                this.setState({ future_visits: future_visits });
                            }
                            else
                                //Если токен недействителен, удаляем его и перенаправляем на страницу входа
                                if('errorAns' in data.body && data.body.errorAns === "Данный токен не действителен.")
                                {
                                    localStorage.removeItem('accessToken');
                                    window.location = "/login";
                                }
                        })
                        .catch((error) => {
                            //Выключаем анимацию загрузки
                            this.setState({loading: false});
                            //Устанавливаем ошибку
                            if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                                this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
                        });
                }
            })
            .catch((error) => {
                //Выключаем анимацию загрузки
                this.setState({loading: false});
                //Устанавливаем ошибку
                if(this.state.error_messages.indexOf("Ошибка получения ответа от сервера") === -1)
                    this.state.update_error_messages_callback([...this.state.error_messages, "Ошибка получения ответа от сервера"]);
            });
    }
}
